class AlertPopup {
	constructor() {
		const popup = document.querySelector("#alert-popup");

		if (popup) {
			const closeBtn = popup.querySelector(".close");
			closeBtn.addEventListener("click", () => {
				popup.classList.add("hidden");
			});
		}
	}
}